/**
 * @generated SignedSource<<0296b4145c577d72e440d235503c8562>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserRolesInput = "AlliedHealthProfessionals" | "Apothecary" | "Dentist" | "Doccheck" | "Doctor" | "Midwife" | "Other" | "PKA" | "PTA" | "PharmaceuticalEngineer" | "%future added value";
export type AddSpecificUserRolesCanStartTreeConfigInput = {
  clientMutationId?: string | null | undefined;
  rootNodeId: string;
  userRoles: ReadonlyArray<UserRolesInput>;
};
export type SpecificUserRolesCanStartTreeConfigForm_AddMutation$variables = {
  input: AddSpecificUserRolesCanStartTreeConfigInput;
};
export type SpecificUserRolesCanStartTreeConfigForm_AddMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly addSpecificUserRolesCanStartTreeConfig: {
        readonly rootNode: {
          readonly " $fragmentSpreads": FragmentRefs<"SpecificUserRolesCanStartTreeConfigForm_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type SpecificUserRolesCanStartTreeConfigForm_AddMutation = {
  response: SpecificUserRolesCanStartTreeConfigForm_AddMutation$data;
  variables: SpecificUserRolesCanStartTreeConfigForm_AddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SpecificUserRolesCanStartTreeConfigForm_AddMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddSpecificUserRolesCanStartTreeConfigPayload",
                "kind": "LinkedField",
                "name": "addSpecificUserRolesCanStartTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SpecificUserRolesCanStartTreeConfigForm_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpecificUserRolesCanStartTreeConfigForm_AddMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddSpecificUserRolesCanStartTreeConfigPayload",
                "kind": "LinkedField",
                "name": "addSpecificUserRolesCanStartTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "structureDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "startConfigs",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isStartTreeConfig"
                                  },
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "configType",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "userRoles",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "SpecifiedUserRolesCanStartTreeConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "RootStructureDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "69039b6d75ba42585ef687c4291c231a",
    "id": null,
    "metadata": {},
    "name": "SpecificUserRolesCanStartTreeConfigForm_AddMutation",
    "operationKind": "mutation",
    "text": "mutation SpecificUserRolesCanStartTreeConfigForm_AddMutation(\n  $input: AddSpecificUserRolesCanStartTreeConfigInput!\n) {\n  Admin {\n    Tree {\n      addSpecificUserRolesCanStartTreeConfig(input: $input) {\n        rootNode {\n          ...SpecificUserRolesCanStartTreeConfigForm_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment SpecificUserRolesCanStartTreeConfigForm_StartTreeConfigFragment on StartTreeConfig {\n  __isStartTreeConfig: __typename\n  ... on SpecifiedUserRolesCanStartTreeConfig {\n    id\n    configType\n    userRoles\n  }\n}\n\nfragment SpecificUserRolesCanStartTreeConfigForm_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      startConfigs {\n        __typename\n        ...SpecificUserRolesCanStartTreeConfigForm_StartTreeConfigFragment\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ef246a3215b26382e78c992ec91e574";

export default node;
